export default __webpack_public_path__ + "static/media/LoginImage.152f3d22.svg";